import ExportAsPdf from './ExportAsPdf';

export default ExportAsPdf;
